import { z } from 'zod'
import { apiResponseSchema } from '../helper/api-response-schema'

/**
 * 產品檔案
 */
export const productFileSchema = z.object({
  /** ID */
  pfID: z.number(),
  /** 子網頁 ID */
  ppID: z.number(),
  /** 檔案名稱 */
  fileName: z.string(),
  /** 檔案大小 */
  fileSize: z.number(),
  /** 副檔名 */
  extension: z.string(),
  /** 原檔名 */
  uploadName: z.string(),
  /** 點擊次數 */
  hits: z.number(),
  /** 語言 */
  languages: z.union([z.literal('zh'), z.literal('en')]),
  /** 修改日期 */
  modifyDate: z.string(),
  /** 修改人 */
  modifyUser: z.string().nullable()
})

export const productFileResponseSchema = apiResponseSchema(productFileSchema)

export const productFileListResponseSchema = apiResponseSchema(
  productFileSchema.array()
)

export interface ProductFile extends z.infer<typeof productFileSchema> {}
export interface ProductFileResponse
  extends z.infer<typeof productFileResponseSchema> {}
export interface ProductFileListResponse
  extends z.infer<typeof productFileListResponseSchema> {}
